import { createStore, applyMiddleware, Store } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';

import { IRootState } from './../reducers';

export const store: Store<IRootState> = createStore(rootReducer, applyMiddleware(thunk));



// WEBPACK FOOTER //
// ./src/utils/store.ts